/** @type {import('styled-components').DefaultTheme} */
import featuredEvent from '../public/assets/icons/featuredevent.jpg';
import tournaments from '../public/assets/icons/tournaments.jpg';
import dailyEvent from '../public/assets/icons/dailyevent.jpg';

const defaultTheme = {
    marketingModalImageMap: {
        featuredEvent,
        tournaments,
        dailyEvent,
    },
    marketingModalTheme: 'default',
};

export default defaultTheme;
